const theme = {
  Heading: "#2a3830",
  Button: "#000",
  BodyColor: "#666",
  whiteColor:"#fff"
};

export default theme;
